<template>
  <div class="row m-3 border-line">
    <div class="col-lg-4 col-md-6 col-xs-6 p-5">
      <div class="ml-25 flex flex-row-wrap mt-5">
        <p class="stimuli-font-size text-overflow mt-5 mb-0">{{ stimulis }}</p>
      </div>
    </div>
    <div class="col-lg-8 col-md-6 col-xs-6 p-10 flex justify-between">
      <template v-if="combinedAnswerExist">
        <div class="flex flex-row-wrap">
          <template v-for="({ maxPoint, minPoint }, skillKey, j) in combinedAnswerWithSkills">
            <div :key="`${skillKey}-${j}`" class="mr-20 ml-5">
              <span class="skill-font-weight skill-font-size" :title="getSkillName(skillKey)">{{
                displayName('', 15, skillKey)
              }}</span
              ><span class="skill-font-size"> ({{ maxPoint }})</span>
              <!-- ><span class="skill-font-size"> ({{ maxPoint }}/{{ minPoint }})</span> -->
            </div>
          </template>
        </div>
        <div>
          <i
            @click="isToggled()"
            style="cursor: pointer"
            :class="['fas', 'mr-20', 'mt-5', 'mb-0', toggled ? 'fa-angle-down' : 'fa-angle-left']"
            data-testid="response-toggle"
          ></i>
        </div>
      </template>
      <template v-else>
        <span class="skill-font-size mt-5 ml-5">No Skills Assigned</span>
      </template>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';

  export default {
    data() {
      return {
        toggled: false,
      };
    },
    props: {
      stimulis: {
        type: String,
        required: true,
      },
      combinedAnswerWithSkills: {
        type: Object,
        required: true,
      },
      questionKey: {
        type: String,
        required: true,
      },
    },
    methods: {
      getSkillName(skillKey) {
        return this.skills[skillKey].name;
      },
      displayName(name, num, skillKey) {
        if (skillKey) name = this.getSkillName(skillKey);

        return name.length > num ? name.substring(0, num + 1) + '...' : name;
      },
      isToggled() {
        this.toggled = !this.toggled;
        this.$emit('click', { toggled: this.toggled, questionKey: this.questionKey });
      },
    },
    computed: {
      ...mapState('editMode/skills', ['skills']),

      combinedAnswerExist() {
        return Object.keys(this.combinedAnswerWithSkills).length;
      },
    },
  };
</script>
<style lang="scss" scoped>
  .stimuli-font-size {
    font-size: 0.875em;
  }
  .skill-font-weight {
    font-weight: bold;
  }
  .skill-font-size {
    font-size: 0.75em;
  }
  .border-line {
    border-top: 1px solid #dddddd;
  }
  .text-overflow {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    width: 90%;
  }
</style>
